import { IWindow } from '../../../../../services/analytics/adapters/mparticle'
import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'
import { Utils } from '../../../../../utils/common'
import { DOMUtils } from '../../../../../utils/dom'
import { ScreenUtils } from '../../../../../utils/screen'

declare let window: IWindow
const UTM_SRC = 'utm_source'

export interface IAttributeFormatter {
    format(attList: string[], eventObj: any): object
}

export class AttributeFormatter implements IAttributeFormatter {

    public static dom() {
        const obj: any = {
            [key.NAME]: location.href.split(location.host)[1],
            [key.CUR_PAGE]: location.href
        }
        if (document.querySelector(`meta[name='description']`)) {
            obj[key.META_DESC] = Utils.decodeHtmlEntity(
                document.querySelector(`meta[name='description']`).getAttribute('content'))
        }

        if (document.querySelector(`meta[name='robots']`)) {
            obj[key.META_ROBOT] = Utils.decodeHtmlEntity(
                document.querySelector(`meta[name='robots']`).getAttribute('content'))
        }

        if (document.querySelector("link[rel='canonical']")) {
            obj[key.CANONICAL_PATH] = DOMUtils.getRelUrl('canonical')
        }
        return obj
    }

    public format(attrs: string[], data: any, altAttrs?: any): any {
        if (attrs.length < 1) {
            return {}
        }

        const fData: any = {}
        if (data) {
            const obj = {...data, ...AttributeFormatter.dom()}
            attrs.forEach((attr) => {
                if (altAttrs && Object.keys(altAttrs).indexOf(attr) > -1 && Object.keys(obj).indexOf(attr) > -1) {
                    fData[altAttrs[attr]] = String(obj[attr])
                } else if (Object.keys(obj).indexOf(attr) > -1) {
                    fData[attr] = String(obj[attr])
                }
            })
        }

        return {
            ...fData,
            ...this.refDetails(attrs),
            ...this.staticValues(attrs, data, altAttrs),
            ...this.formatVideoAttr(attrs, data)
        }
    }

    // tslint:disable: cognitive-complexity
    public staticValues(attrs: string[], data: any, altAttrs?: any): object {
        const obj: any = {}
        if (attrs.length > 0) {
            if (altAttrs && Object.keys(altAttrs).indexOf(key.FORMAT) > -1) {
                obj[altAttrs[key.FORMAT]] = 'HTML5'
            } else if (attrs.indexOf(key.FORMAT) > -1) {
                obj[key.FORMAT] = 'HTML5'
            }
            if (altAttrs && Object.keys(altAttrs).indexOf(key.GLOBAL_ID) > -1) {
                obj[altAttrs[key.GLOBAL_ID]] = data[key.ARTICLE_ID] + ', ' + data[key.ORIGINAL_ID]
            } else if (attrs.indexOf(key.GLOBAL_ID) > -1) {
                obj[key.GLOBAL_ID] = data[key.ARTICLE_ID] + ', ' + data[key.ORIGINAL_ID]
            }
            if (attrs.indexOf(key.PAGEVIEW_INIT_PRCNT) > -1) {
                obj[key.PAGEVIEW_INIT_PRCNT] = String(ScreenUtils.initPageYcord())
            }
            if (attrs.indexOf(key.PAGEVIEW_PRCNT) > -1) {
                obj[key.PAGEVIEW_PRCNT] = String(ScreenUtils.crntPageYcord())
            }
            if (altAttrs && Object.keys(altAttrs).indexOf(key.VERSION) > -1) {
                obj[altAttrs[key.VERSION]] = 'Desktop'
            } else if (attrs.indexOf(key.VERSION) > -1) {
                obj[key.VERSION] = 'Desktop'
            }
        }
        return obj
    }

    public refDetails(attrs: string[]): object {
        const obj: any = {}
        if (attrs.indexOf(key.REF_DETAILS) > -1) {
            const params = Utils.urlParams(document.location)
            if (params.has(UTM_SRC)) {
                obj[key.REF_DETAILS] = params.get(UTM_SRC)
            }
        }
        return obj
    }

    public formatVideoAttr(attrs: string[], data: any) {
        const obj: any = {}
        if (attrs.indexOf(key.VID_NAME_PATH) > -1 && data[key.CATEGORY]) {
            obj[key.VID_NAME_PATH] = data[key.CATEGORY].replace(/, /g, '>')
        }
        if (attrs.indexOf(key.VID_PUB_DATE) > -1) {
            obj[key.VID_PUB_DATE] = data[key.PUB_DATE]
        }
        return obj
    }

    // format social share click event attributes
    public formatSocialShareAttr(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.chnl) {
                obj[key.SCL_SHARE_CHANNEL] = data.chnl
            }
            if (data.loc) {
                obj[key.SCL_SHARE_LOC] = data.loc
            }
        }
        return obj
    }

    // format search event attributes
    public searchAttrformat(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.keys) {
                obj[key.SRCH_KEY_WORDS] = data.keys
            }
            if (data.rsltCnt > -1) {
                obj[key.SRCH_RSLT_CNT] = String(data.rsltCnt)
            }
        }
        return obj
    }

    // format campaign event attributes
    public cmpgnAttrformat(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.id) {
                obj[key.CMPGN_ID] = String(data.id)
            }
            if (data.type) {
                obj[key.CMPGN_TYPE] = String(data.type)
            }
        }
        return obj
    }

    // format campaign event attributes
    public intrnlPromoClkAttrformat(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.loc) {
                obj[key.BTN_LOC] = data.loc
            }
            if (data.name) {
                obj[key.INTRNL_PROM_NAME] = data.name
            }
        }
        return obj
    }

    // format subscribe button click event
    public subsBtnClkAttrformat(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.action) {
                obj[key.SUB_BTN_ACTN] = data.action
            }
            if (data.newsltr) {
                obj[key.SUB_BTN_NEWS] = data.newsltr
            }
            if (data.src) {
                obj[key.SUB_BTN_SRC] = data.src
            }
            if (data.topic) {
                obj[key.SUB_BTN_TOPIC] = data.topic
            }
        }
        return obj
    }

    // format video center event attribute
    public vidCenterAttrformat(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.vidId) {
                obj[key.VID_ID] = data.vidId
            }
            if (data.url) {
                obj[key.URL] = data.url
            }
            if (data.outfit) {
                obj[key.OUTFIT] = data.outfit
            }
            if (data.outfitPos) {
                obj[key.OUTFIT_POS] = data.outfitPos
            }
        }
        return obj
    }

    // format button click event attribute
    public btnClkAttrFormat(data: any): object {
        const obj: any = {}
        if(data) {
            if (data.name) {
                obj[key.BTN_NAME] = data.name
            }
            if (data.loc) {
                obj[key.BTN_LOC] = data.loc
            }
            if (data.text) {
                obj[key.BTN_TEXT] = data.text
            }
            if (data.url) {
                obj[key.BTN_URL] = data.url
            }
        }
        return obj
    }

    // format photo gallery attribute
    public photoGalleryFormat(data: any): object {
        const obj: any = {}
        if (data && data.name) {
            obj[key.PHOTO_NAME] = data.name
        }
        return obj
    }

    // error attribute formate
    public errorFormat(data: any): object {
        const obj: any = {}
        if (data && data[key.ERROR]) {
            obj[key.ERROR_MSG] = '404 Error'
        }
        return obj
    }

    // @TODO: test case for async returned value
    public async mParticleId() {
        return await new Promise((resolve, reject) => {
            window.mParticle.ready(() => {
                if (!window.mParticle.Identity.getCurrentUser()) {
                    return reject(new Error('mParticle Identity not initialized'))
                }
                resolve(window.mParticle.Identity.getCurrentUser().getMPID())
            })
        })
    }
}
